import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'nwTimer'
})
export class TimerPipe implements PipeTransform {

    transform(value: any, args?: any): number {
        if(value){
            const diff = new Date(value).getTime() - new Date().getTime();
            if(diff >= 1000) {
                return diff;
            }
        }
        return 0;
    }

}


// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/shared/pipes/timer.pipe.ts